import produce from 'immer';

import { TConfig, TConfigInput, TConfigParams } from '@@/auto/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';
import { featureFlag } from '../../featureFlags';

function ToggleWIConfig({
  isFeatureEnabled,
}: TConfigParams): DeepPartial<TConfigInput> {
  return isFeatureEnabled(featureFlag.IS_WI_ENABLED)
    ? {
        autoDiscounts: [
          AUTO_DISCOUNTS.affinity,
          AUTO_DISCOUNTS.safeDriving,
          AUTO_DISCOUNTS.multiCar,
          AUTO_DISCOUNTS.multiPolicy,
          AUTO_DISCOUNTS.homeowner,
          AUTO_DISCOUNTS.goodStudent,
          AUTO_DISCOUNTS.distantStudent,
          AUTO_DISCOUNTS.teenDriver,
        ],
        coverage: (coverage: TConfig['coverage']) => ({
          ...coverage,
          compColl: {
            ...coverage.compColl,
            modalContent:
              'Comprehensive can pay up to the limits chosen for accidental damage to your car from things other than a collision - like floods, hail, fire, theft, and windshield or animal damage. In addition, coverage includes Electric Vehicle Charger Coverage for a vehicle that has Comprehensive coverage and is an electric vehicle. Collision can pay up to the limits chosen for accidental damage to your car caused by collision with another vehicle or fixed object. Deductibles chosen are per vehicle.',
          },
        }),
        visibleCoverages: (visibleCoverages: TConfig['visibleCoverages']) => {
          return {
            ...visibleCoverages,
            protectionCoverages: [
              ...visibleCoverages.protectionCoverages.filter(
                ({ key }) =>
                  ![
                    'pet_passenger',
                    'underinsured_motorist_bodily_injury_limit',
                  ].includes(key)
              ),
              {
                label: 'Underinsured Motorist Bodily Injury',
                key: 'underinsured_motorist_bodily_injury_limit',
              },
              visibleCoverages.protectionCoverages.find(
                ({ key }) => key === 'pet_passenger'
              ),
            ],
            vehicleCoverages: [
              ...visibleCoverages.vehicleCoverages.filter(
                ({ key }) =>
                  !['uninsured_motorist_property_damage_limit'].includes(key)
              ),
            ],
          };
        },
        vehicleSideEffectMessages: (
          vehicleSideEffectMessages: TConfig['vehicleSideEffectMessages']
        ) =>
          produce(vehicleSideEffectMessages, (draft) => {
            draft.gap =
              'This coverage is only available if Comprehensive & Collision is also selected, the vehicle is financed or leased, and the model year is four (4) years old or less.';
            draft.new_car_replacement = `This coverage is only available with a model year that's 2 years old or less.`;
            draft.oem_parts = `This coverage is only available with a model year that's 10 years old or less.`;
            draft.towing_road_services = `This coverage is only available if Comprehensive & Collision is also selected.`;
            draft.temporary_ride = `This coverage is only available if Comprehensive & Collision is also selected.`;
          }),
        initialCoverageValues: (
          initialCoverageValues: TConfig['initialCoverageValues']
        ) => ({
          ...initialCoverageValues,
          gap: 'false',
          temporary_ride: 'null',
          side_hustle: 'false',
        }),
      }
    : {};
}
export default ToggleWIConfig;
